module.exports = __webpack_public_path__ + "static/google-play-badge-8ca09bb89667df1e76b1d5195d7863fc.png";